export default __webpack_public_path__ + "static/media/left-mobile.2b2981f8.svg";